import { z } from "zod";

export interface Resource {
  id?: number;
  demanda: number; 
  descricao: string;
  obs?: string; 
}


export const schema = z.object({
  id: z.number().optional(),
  demanda: z.number().min(0, "Demanda deve ser um número positivo"),
  descricao: z.string().min(1, "Descrição é obrigatória"),
  obs: z.string().optional(),
});

export type FormValues = z.infer<typeof schema>;

export function resourceToFormValues({
  demanda,
  descricao,
  obs,
  id,
  ...values
}: Resource): FormValues {
  return {
    ...values,
    id,
    demanda,
    descricao,
    obs: obs || "", 
  };
}

export function formValuesToResource({
  demanda,
  descricao,
  obs,
  id,
  ...values
}: FormValues): Resource {
  return {
    ...values,
    id,
    demanda,
    descricao,
    obs: obs || undefined, 
  };
}